import { handleRequest } from "../utilities/requestHandler";

export const getRecentOrdersBySite = ({ site_number, limit = 3 }) =>
	handleRequest("post", "/orders/getRecentOrdersBySite", { site_number, limit });

export const searchTrackOrders = ({ site_number, searchTerm }) =>
	handleRequest("post", "/orders/searchTrackOrders", { site_number, searchTerm });
